export enum GoogleAuthProvider {
  GoogleApp = 'google_app',
  GoogleWeb = 'google_web',
}

export const GOOGLE_OAUTH_BASE_URL =
  'https://accounts.google.com/o/oauth2/v2/auth';
export const GOOGLE_OAUTH_SCOPES = ['email', 'profile'];
export const GOOGLE_OAUTH_STATE = 'google';
export const GOOGLE_OAUTH_REDIRECT_URI = '/authenticate/login/third-party';
